/**
 * Shared formatters for the Salesperson Performance card, so member rows and
 * team subtotal rows render numbers identically.
 */

const CURRENCY = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatCurrency(value: number): string {
  return CURRENCY.format(value);
}

export function formatPerUnit(value: number | null): string {
  if (value === null || value === undefined) return '-';
  return CURRENCY.format(value);
}

/**
 * Unit counts are fractional when a deal is split between two salespeople
 * (each gets 0.5), so show one decimal only when there is one: 8.5, not 8.5/8.0.
 */
export function formatUnits(value: number): string {
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}
